import { AxiosRequestBuilder } from '../../../services/axiosRequestBuilder';
import {
  ApiQuestion,
  ListProvasRespondidasProps,
  Question,
  QuestionFormResponse,
} from '../../questionnaire/types/questionnaire.types';
import { QuestionAdapter } from '../../questionnaire/utils/questionAdapter';

export const questionnaireViewerService = {
  listProvas: async (
    signal?: AbortSignal
  ): Promise<ListProvasRespondidasProps[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/ListProvasByPersonId')
      .setResponseType('json')
      .setSignal(signal)
      .send<ListProvasRespondidasProps[]>();

    return data;
  },

  getPesquisa: async (
    workshopUId: string,
    signal?: AbortSignal
  ): Promise<Question[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/ListaQuestaoPesquisa')
      .setParams({ workshopUId })
      .setResponseType('json')
      .setSignal(signal)
      .send<ApiQuestion[]>();

    return QuestionAdapter.fromApi(data);
  },

  getRespostas: async (
    workshopUId: string,
    signal?: AbortSignal
  ): Promise<QuestionFormResponse[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/RespostasV2')
      .setParams({ workshopUId })
      .setResponseType('json')
      .setSignal(signal)
      .send<QuestionFormResponse[]>();

    return data;
  },
};
